interface IIconProps {
  size?: number;
}

/** Icono base: hereda el color del texto y el grosor de trazo del sistema */
const Svg = ({
  size = 16,
  children,
}: IIconProps & { children: React.ReactNode }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const GiftIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8" />
    <path d="M2 7h20v5H2z" />
    <path d="M12 21V7" />
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
  </Svg>
);

export const UploadIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <path d="M17 8l-5-5-5 5" />
    <path d="M12 3v12" />
  </Svg>
);

export const DownloadIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <path d="M7 10l5 5 5-5" />
    <path d="M12 15V3" />
  </Svg>
);

export const SendIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M22 2 11 13" />
    <path d="M22 2 15 22l-4-9-9-4z" />
  </Svg>
);

export const RefreshIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M21 12a9 9 0 1 1-3-6.7" />
    <path d="M21 3v6h-6" />
  </Svg>
);

export const FileIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
  </Svg>
);

export const TemplateIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18" />
    <path d="M9 9v12" />
  </Svg>
);

export const CloseIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M18 6 6 18" />
    <path d="M6 6l12 12" />
  </Svg>
);

export const AlertIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v4" />
    <path d="M12 16h.01" />
  </Svg>
);

export const InfoIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </Svg>
);

export const ClockIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Svg>
);

export const InboxIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M22 12h-6l-2 3h-4l-2-3H2" />
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
  </Svg>
);

export const MicrosoftIcon = ({ size = 16 }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 23 23"
    aria-hidden="true"
    focusable="false"
  >
    <path fill="#f25022" d="M1 1h10v10H1z" />
    <path fill="#7fba00" d="M12 1h10v10H12z" />
    <path fill="#00a4ef" d="M1 12h10v10H1z" />
    <path fill="#ffb900" d="M12 12h10v10H12z" />
  </svg>
);

export const HelpIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M2 4h6a3 3 0 0 1 3 3v13a2.5 2.5 0 0 0-2.5-2.5H2z" />
    <path d="M22 4h-6a3 3 0 0 0-3 3v13a2.5 2.5 0 0 1 2.5-2.5H22z" />
  </Svg>
);

export const LogoutIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </Svg>
);

export const ChevronLeftIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M15 18l-6-6 6-6" />
  </Svg>
);

export const ChevronRightIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M9 18l6-6-6-6" />
  </Svg>
);

export const ChevronDownIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);

export const FilterIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M3 4h18l-7 8v6l-4 2v-8z" />
  </Svg>
);

export const FilterOffIcon = ({ size }: IIconProps) => (
  <Svg size={size}>
    <path d="M3 4h18l-7 8v6l-4 2v-8z" />
    <path d="M2 2l20 20" />
  </Svg>
);
